import { Rows } from '../../interfaces';
import { formats, getCell, spaceInsteadOfNull, withCellStyles } from '../../utils';
import { centeredBoldGrayForHeaders, left } from 'src/app/util/excelStyles';
import { getFirstRowHeader, getSecondRowHeaderForDisplay, getSecondRowHeaderForLogic } from './headers';
import { MarketAnalysisByVintageChartDTO } from '../../../market-analysis/dto/MaByIndustryChartDTO';

export const getPreparedData = (data: MarketAnalysisByVintageChartDTO): Rows => {
  const newData: Rows = [];
  const firstRowHeaders = getFirstRowHeader();
  const secondRowHeadersForDisplay = getSecondRowHeaderForDisplay();
  const designedHeaderRow = [];
  secondRowHeadersForDisplay.forEach((header) => designedHeaderRow.push(withCellStyles(header, centeredBoldGrayForHeaders)));
  const headersForLogic = getSecondRowHeaderForLogic();
  newData.push(firstRowHeaders);
  newData.push(designedHeaderRow);
  const rows = getManyRows(data, headersForLogic);
  newData.push(...rows);
  return newData;
};

const getManyRows = (data: MarketAnalysisByVintageChartDTO, headers: string[]): Rows => {
  const rows: Rows = [];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  const mappedToHeaders = data.tvpiChartData.periodsArr.map((per, i) => getNewMapping(data, i));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header], left));
    }
    rows.push(row);
  }
  return rows;
};


const getNewMapping = (marketData: MarketAnalysisByVintageChartDTO, index: number): any => {
  return {
    Vintage: marketData.tvpiChartData.periodsArr[index],
    empty: null,

    // TVPI SECTION
    Bottom0: getCell({
      v: marketData.tvpiChartData.bottomArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Median0: getCell({
      v: marketData.tvpiChartData.medianArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Top0: getCell({
      v: marketData.tvpiChartData.topArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Fund0: getCell({
      v: spaceInsteadOfNull(marketData.tvpiChartData.selectedFundArr[index]),
      z: formats.multiplier,
      t: 'n',
    }),
    empty0: null,

    // Net IRR SECTION
    Bottom1: getCell({
      v: marketData.netIrrChartData.bottomArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Median1: getCell({
      v: marketData.netIrrChartData.medianArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Top1: getCell({
      v: marketData.netIrrChartData.topArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Fund1: getCell({
      v: spaceInsteadOfNull(marketData.netIrrChartData.selectedFundArr[index]),
      z: formats.multiplier,
      t: 'n',
    }),
    empty1: null,

    // MOIC SECTION
    Bottom2: getCell({
      v: marketData.moicChartData.bottomArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Median2: getCell({
      v: marketData.moicChartData.medianArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Top2: getCell({
      v: marketData.moicChartData.topArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Fund2: getCell({
      v: spaceInsteadOfNull(marketData.moicChartData.selectedFundArr[index]),
      z: formats.multiplier,
      t: 'n',
    }),
    empty2: null,

    // PORTFOLIO IRR SECTION
    Bottom3: getCell({
      v: marketData.grossIrrChartData.bottomArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Median3: getCell({
      v: marketData.grossIrrChartData.medianArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Top3: getCell({
      v: marketData.grossIrrChartData.topArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Fund3: getCell({
      v: spaceInsteadOfNull(marketData.grossIrrChartData.selectedFundArr[index]),
      z: formats.multiplier,
      t: 'n',
    }),
    empty3: null,

    // Contribution SECTION
    Called4: getCell({
      v: marketData.contributionChartData.averageContribution[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Unfunded4: getCell({
      v: marketData.contributionChartData.restArr[index],
      z: formats.multiplier,
      t: 'n',
    }),
    Fund4: getCell({
      v: spaceInsteadOfNull(marketData.contributionChartData.selectedFundArr[index]),
      z: formats.multiplier,
      t: 'n',
    }),
  };
};

